import { appHttpRequest } from '../../../utils/AppHttpRequest';
import { ciHttpRequest } from '../../../utils/CiHttpRequest';
import {
	IPurchasePoSearch,
	IPurchasePoDetail,
	IPurchasePoStatistics,
} from './vrmBillPurchasePoType';
class PurchasePoService {
	
	async total(searchVo: IPurchasePoSearch) {
		const apiUrl = '/vrm2/purchase/total';
		return await appHttpRequest.post<IPurchasePoStatistics>(apiUrl, searchVo);
	}
	async one(id: string,userBranch:string) {
		const apiUrl = userBranch=='vrm'?`/vrm2/purchase/findById/${id}`:`/ci-storage/purchase/findById/${id}`;
		return await userBranch=='vrm'?appHttpRequest.get<IPurchasePoDetail>(apiUrl):ciHttpRequest.get<IPurchasePoDetail>(apiUrl);
	}
}

export const purchasePoService = new PurchasePoService();
